<template>
	<div>
		<app-layout>
			<template v-slot:header>
				<Header :title="$t('results')"
                        :is-filter="false"
				        @filter-div-status="datatable.filterStatus = $event">
				</Header>
			</template>
			<template v-slot:header-mobile>
				<HeaderMobile :title="$t('results')"
                              :is-filter="false"
				              @filter-div-status="datatable.filterStatus = $event">
				</HeaderMobile>
			</template>
			<datatable :isLoading.sync="datatable.isLoading"
			           :columns="datatable.columns"
			           :rows="datatable.rows"
			           :total="datatable.total"
			           :queryParams="datatable.queryParams"
			           :lineNumbers="false"
			           @on-page-change="onPageChange"
			           @on-sort-change="onSortChange"
			           @on-per-page-change="onPerPageChange"
			           v-show="datatable.showTable">
			</datatable>
		</app-layout>
	</div>
</template>
<script>
  //Template
	import AppLayout from "@/layouts/AppLayout"
	import Header from "@/layouts/AppLayout/Header"
	import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

  //Component
  import Datatable from "@/components/datatable/Datatable";

  // Services
  import StudentClubVoteResultService from '@/services/StudentClubVoteResultService';

    // Other
	import {ValidationObserver, ValidationProvider} from "vee-validate";

	export default {
		components: {
			AppLayout,
			Header,
			HeaderMobile,

			Datatable,
			ValidationProvider,
			ValidationObserver,
		},
		metaInfo() {
			return {
				title: this.$t('results')
			}
		},
		data() {
			return {
        studentClubVoteId: null,
				datatable: {
					isLoading: false,
					columns: [
						{
							label: this.$t('id'),
							field: 'id',
							sortable: true,
              hidden:true
						},
            {
							label: this.$t('option'),
							field: 'option',
							sortable: true,
              hidden:false
            },
            {
							label: this.$t('count'),
							field: 'count',
							sortable: true,
              hidden:false
            },
					],
					rows: [],
					total: 0,
					filterStatus: true,
					showTable: false,
					queryParams: {
						filter: {},
						sort: 'id',
						page: 1,
						limit: 20
					}
				}
			}
		},
		methods: {
			filter() {
        this.datatable.queryParams.page = 1;
				this.getRows();
			},
			onPageChange(params) {
				this.datatable.queryParams.page = params.currentPage;
				this.getRows();
			},
			onPerPageChange(params) {
				this.datatable.queryParams.limit = params.currentPerPage;
				this.datatable.queryParams.page = 1;
				this.getRows();
			},
			onSortChange(params) {
				const sortType = params[0].type == 'desc' ? '-' : '';
				this.datatable.queryParams.sort = sortType + params[0].field
				this.getRows();
			},
			getRows() {
				this.datatable.showTable = true;
				this.datatable.isLoading = true;

				return StudentClubVoteResultService.get(this.studentClubVoteId)
				                     .then((response) => {
					                     this.datatable.rows = response.data.data
				                     })
				                     .finally(() => {
					                     this.datatable.isLoading = false;
				                     });
			},
		},
        created() {
            this.studentClubVoteId = this.$route.params.id;
            this.filter();
        },
	};
</script>

